<template>
    <section id="datasekolah">
        <div class="rows">
            <!-- <div class="row">
                <b-button  class="button is-primary" 
                tag="router-link"
                to="/biro/berandasekolah"
                icon-left="arrow-left-bold">Kembali</b-button>
            </div> -->
            <div class="row">
                <div class="box mw-980">
                    <h4 class="title is-5 has-text-centered">{{ actionTitle }} Data Sekolah</h4>
                    <section>
                        <b-field horizontal label="Nama Sekolah"
                        :type="form.nama_sekolah.type"
                        :message="form.nama_sekolah.message">
                            <b-input name="nama_sekolah" @input="clearError(form.nama_sekolah)"
                            placeholder="Nama Sekolah" v-model="form.nama_sekolah.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Nama Kepala Sekolah"
                        :type="form.nama_kepala_sekolah.type"
                        :message="form.nama_kepala_sekolah.message">
                            <b-input name="nama_kepala_sekolah" @input="clearError(form.nama_kepala_sekolah)"
                                placeholder="Nama Kepala Sekokah" v-model="form.nama_kepala_sekolah.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Alamat"
                        :type="form.alamat.type"
                        :message="form.alamat.message">
                            <b-input name="alamat" @input="clearError(form.alamat)"
                                placeholder="Alamat" v-model="form.alamat.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Kota"
                        :type="form.kota.type"
                        :message="form.kota.message">
                            <b-input name="kota"  @input="clearError(form.kota)"
                                placeholder="Kota" v-model="form.kota.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Provinsi"
                        :type="form.provinsi.type"
                        :message="form.provinsi.message">
                            <b-input name="provinsi"  @input="clearError(form.provinsi)"
                                placeholder="Provinsi" v-model="form.provinsi.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Status Sekolah"
                        :type="form.status_sekolah.type"
                        :message="form.status_sekolah.message">
                            <b-select  v-model="form.status_sekolah.value" @input="clearError(form.status_sekolah)" placeholder="Select One" expanded>
                                <option value="Swasta">Swasta</option>
                                <option value="Negeri">Negeri</option>
                            </b-select>
                        </b-field>
                        <b-field horizontal label="Email Sekolah"
                        :type="form.email.type"
                        :message="form.email.message">
                            <b-input name="email" placeholder="Email" v-model="form.email.value"  @input="clearError(form.email)" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Jenjang Sekolah"
                        :type="form.jenjang_sekolah.type"
                        :message="form.jenjang_sekolah.message" >
                            <b-select placeholder="Select one" v-model="form.jenjang_sekolah.value"  @input="clearError(form.jenjang_sekolah)" expanded>
                                <!-- <option value="TK">TK</option> -->
                                <option value="SD">SD</option>
                                <option value="SMP">SMP</option>
                                <option value="SMA/SMK">SMA/SMK</option>
                            </b-select>
                        </b-field>

                        <!-- <b-field label="No Telepon horizontal"> -->
                        <b-field label="No Telepon" horizontal
                        :type="form.no_telepon.type"
                        :message ="form.no_telepon.message">

                        <div class="columns">
                            <div class="column is-1">
                                <b-button label="+62" 
                                    type="is-light"
                                    disabled>
                                </b-button>
                            </div>
                            <div class="column">
                                <b-input name="no_telepon" placeholder="No Telepon" 
                                    @input="clearError(form.no_telepon)" v-model="form.no_telepon.value" expanded>
                                </b-input>
                            </div>
                        </div>
                        </b-field>
                        <b-field horizontal label="Total Guru"
                        :type="form.total_guru.type"
                        :message="form.total_guru.message"
                        v-model="form.total_guru.value" >
                        <b-numberinput v-model="form.total_guru.value" @input="clearError(form.total_guru)" min="0"></b-numberinput>
                        </b-field>
                        <b-field horizontal label="Total Rombel"
                        :type="form.total_rombel.type"
                        :message="form.total_rombel.message"
                        v-model="form.total_rombel.value" >
                        <b-numberinput v-model="form.total_rombel.value" @input="clearError(form.total_rombel)" min="0"></b-numberinput>
                        </b-field>
                        <!-- <b-field horizontal>
                            <p class="control">
                                <button class="button is-primary"
                                @click="confirm()">
                                Simpan
                                </button>
                            </p>
                        </b-field>            -->
                    </section>
                    <div class="rows" style="margin-top: 24px">
                        <div class="row">
                            <div class="columns">
                                <div class="column">
                                    <b-button type="is-danger" 
                                    class="mw-420" 
                                    tag="router-link"
                                    to="/biro/berandasekolah">Batal</b-button>
                                </div>
                                <div class="column">
                                    <b-button type="is-info" class="mw-420" @click="confirm()">Simpan</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-loading 
            :is-full-page="true" 
            :active.sync="isLoading" 
            :can-cancel="false">
        </b-loading>   
    </section>
</template>

<script>
    export default {
        data() {
            return {
                //file:null,
                isLoading:false,
                actionTitle:'',
                editID:0,
                activeBiro:Object,
                dataSekolah: new FormData(),
                editDataSekolah:{},
                form:
                {
                    nama_sekolah:{value:'', type:'', message:''},
                    nama_kepala_sekolah:{value:'',type:'',message:''},
                    alamat:{value:'',type:'',message:''},
                    kota:{value:'',type:'',message:''},
                    provinsi:{value:'',type:'',message:''},
                    status_sekolah:{value:'',type:'',message:''},
                    email:{value:'',type:'',message:''},
                    jenjang_sekolah:{value:'',type:'',message:''},
                    no_telepon:{value:'',type:'',message:''},
                    total_guru:{value: 0,type:'',message:''},
                    total_rombel:{value:0,type:'',message:''},
                    nama_biro:{value:'',type:'',message:''}

                },
                snackbarMesssage:'',
                biros:[],
                config: {}
            }
        },
        methods:{
            //
            // getBiro()
            // {
            //     var uri = this.$apiUrl + 'biro'
            //     this.$http.get(uri).then(response=>
            //     {
            //         this.biros = response.data.value
            //     })
            // },
            getData(editID)
            {
                var uri = this.$apiUrl + 'sekolah/' + editID

                this.$http.get(uri, this.config).then(response=>{
                    this.editDataSekolah= response.data.value
                    this.formEdit(this.editDataSekolah)
                })
            },
            formEdit(dataSekolah)
            {
                this.form.nama_sekolah.value = dataSekolah.nama_sekolah;
                this.form.nama_kepala_sekolah.value = dataSekolah.nama_kepala_sekolah;
                this.form.alamat.value = dataSekolah.alamat;
                this.form.kota.value = dataSekolah.kota;
                this.form.provinsi.value = dataSekolah.provinsi;
                this.form.status_sekolah.value = dataSekolah.status_sekolah;
                this.form.email.value = dataSekolah.email;
                this.form.jenjang_sekolah.value = dataSekolah.jenjang_sekolah;
                this.form.no_telepon.value = dataSekolah.no_telepon;
                this.form.total_guru.value = dataSekolah.total_guru;
                this.form.total_rombel.value = dataSekolah.total_rombel
               // this.form.nama_biro.value = dataSekolah.id_biro;
            },
             clearError(form)
            {
                console.log(form)
                form.type = ''
                form.message = ''
            },
            checkDataTambah()
            {
                let count = 0
                let regexAngka = new RegExp(/^\d+$/)
                let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
                // let regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                if(this.form.nama_sekolah.value === "")
                {
                    this.form.nama_sekolah.type = 'is-danger'
                    this.form.nama_sekolah.message = "Nama Sekolah harus di isi"
                    count ++
                }
                if(this.form.nama_kepala_sekolah.value === "")
                {
                    this.form.nama_kepala_sekolah.type = 'is-danger'
                    this.form.nama_kepala_sekolah.message ="Nama Kepala Sekolah harus diisi"
                    count ++
                }
                if(this.form.alamat.value ==="")
                {
                    this.form.alamat.type ='is-danger'
                    this.form.alamat.message ="Alamat harus diisi"
                    count ++
                }
                if(this.form.kota.value ==="")
                {
                    this.form.kota.type = 'is-danger'
                    this.form.kota.message ="Kota Sekolah harus diisi "
                    count ++
                }
                 if(this.form.status_sekolah.value ==="")
                {
                    this.form.status_sekolah.type ='is-danger'
                    this.form.status_sekolah.message ="Status Sekolah harus diisi"
                    count ++
                }
                if(this.form.email.value ==="")
                {
                    this.form.email.type ='is-danger'
                    this.form.email.message ="Email harus diisi"
                    count ++
                }else if(!regexEmail.test(this.form.email.value))
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus valid"
                    count ++
                }
                if(this.form.jenjang_sekolah.value ==="")
                {
                    this.form.jenjang_sekolah.type ='is-danger'
                    this.form.jenjang_sekolah.message ="Jenjang Sekolah Harus diisi"
                    count ++
                }
                if(this.form.kota.value ==="")
                {
                    this.form.kota.type ='is-danger'
                    this.form.kota.message ="Kota Harus diisi"
                    count ++
                }
                if(this.form.provinsi.value ==="")
                {
                    this.form.provinsi.type ='is-danger'
                    this.form.provinsi.message ="Provinsi Harus diisi"
                    count ++
                }
                if(this.form.no_telepon.value ==="")
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="Telepon Harus diisi" 
                    count ++
                }else if(!regexAngka.test(this.form.no_telepon.value))
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="No telepon diisi tanpa spasi dan karakter"
                    count ++
                }else if(this.form.no_telepon.value.length < 9 || this.form.no_telepon.value.length > 13)
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message = "Panjang No telepon 9 - 13 digit"
                    count ++
                }
                if(this.form.total_guru.value === 0)
                {
                    this.form.total_guru.type ='is-danger'
                    this.form.total_guru.message =" Total Guru Harus diisi" 
                    count ++
                }
                // if(!regexAngka.test(this.form.total_guru.value))
                // {
                //     this.form.total_guru.type ='is-danger'
                //     this.form.total_guru.message ="Total Guru berupa angka "
                //     count ++
                // }
                 if(this.form.total_rombel.value === 0)
                {
                    this.form.total_rombel.type ='is-danger'
                    this.form.total_rombel.message =" Total Rombel Harus diisi" 
                    count ++
                }
                //   if(!regexAngka.test(this.form.total_rombel.value))
                // {
                //     this.form.total_rombel.type ='is-danger'
                //     this.form.total_rombel.message ="Total Rombel berupa angka "
                //     count ++
                // }
                // if(this.form.nama_biro.value ==="")
                // {
                //     this.form.nama_biro.type ='is-danger'
                //     this.form.nama_biro.message =" Biro harus diisi" 
                //     count ++
                // }
               
                if(count >0)
                return false
            },

            checkDataUbah()
            {
                let count = 0
                let regexAngka = new RegExp(/^\d+$/)
                let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
                // let regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                if(this.form.nama_sekolah.value === null)
                {
                    this.form.nama_sekolah.type = 'is-danger'
                    this.form.nama_sekolah.message = "Nama Sekolah harus di isi"
                    count ++
                }
                if(this.form.nama_kepala_sekolah.value === null )
                {
                    this.form.nama_kepala_sekolah.type = 'is-danger'
                    this.form.nama_kepala_sekolah.message ="Nama Kepala Sekolah harus diisi"
                    count ++
                }
                if(this.form.alamat.value === null )
                {
                    this.form.alamat.type ='is-danger'
                    this.form.alamat.message ="Alamat harus diisi"
                    count ++
                }
                if(this.form.kota.value ===null)
                {
                    this.form.kota.type = 'is-danger'
                    this.form.kota.message ="Kota Sekolah harus diisi "
                    count ++
                }
                if(this.form.provinsi.value ===null)
                {
                    this.form.provinsi.type = 'is-danger'
                    this.form.provinsi.message ="Provinsi harus diisi "
                    count ++
                }
                 if(this.form.status_sekolah.value === null)
                {
                    this.form.status_sekolah.type ='is-danger'
                    this.form.status_sekolah.message ="Status Sekolah harus diisi"
                    count ++
                }
                if(this.form.email.value ===null)
                {
                    this.form.email.type ='is-danger'
                    this.form.email.message ="Email harus diisi"
                    count ++
                }else if(!regexEmail.test(this.form.email.value))
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus valid"
                    count ++
                }
                if(this.form.jenjang_sekolah.value === null || this.form.jenjang_sekolah.value === "")
                {
                    this.form.jenjang_sekolah.type ='is-danger'
                    this.form.jenjang_sekolah.message ="Jenjang Sekolah Harus diisi"
                    count ++
                }
                if(this.form.no_telepon.value ===null)
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="Telepon Harus diisi" 
                    count ++
                }else if(!regexAngka.test(this.form.no_telepon.value))
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message ="No telepon diisi tanpa spasi dan karakter"
                    count ++
                }else if(this.form.no_telepon.value.length < 9 || this.form.no_telepon.value.length > 13)
                {
                    this.form.no_telepon.type ='is-danger'
                    this.form.no_telepon.message = "Panjang No telepon 9 - 13 digit"
                    count ++
                }
                if(this.form.total_guru.value === 0)
                {
                    this.form.total_guru.type ='is-danger'
                    this.form.total_guru.message =" Total Guru Harus diisi" 
                    count ++
                }
                 if(this.form.total_rombel.value === 0)
                {
                    this.form.total_rombel.type ='is-danger'
                    this.form.total_rombel.message =" Total Rombel Harus diisi" 
                    count ++
                }
                if(count >0)
                return false
            },
            tambahData()
            {
                this.isLoading = true
                if(this.checkDataTambah()== false)
                {
                    this.snackbar("Gagal...Silahkan input lagi", 'is-danger')
                    this.isLoading = false
                }else{
                    this.dataSekolah.append("nama_sekolah",this.form.nama_sekolah.value)
                    this.dataSekolah.append("nama_kepala_sekolah",this.form.nama_sekolah.value)
                    this.dataSekolah.append("alamat",this.form.alamat.value)
                    this.dataSekolah.append("kota",this.form.kota.value)
                    this.dataSekolah.append("status_sekolah",this.form.status_sekolah.value)
                    this.dataSekolah.append("email",this.form.email.value)
                    this.dataSekolah.append("provinsi",this.form.provinsi.value)
                    this.dataSekolah.append("jenjang_sekolah",this.form.jenjang_sekolah.value)
                    this.dataSekolah.append("no_telepon",this.form.no_telepon.value)
                    this.dataSekolah.append("total_guru",this.form.total_guru.value)
                    this.dataSekolah.append("total_rombel",this.form.total_rombel.value)
                    this.dataSekolah.append("id_biro",this.activeBiro.id_biro)
                   

                    var uri =this.$apiUrl + 'sekolah';
                    this.$http.post(uri,this.dataSekolah, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({ name :"BerandaSekolah"})
                        this.snackbarMessage = response.data.Message
                        console.log(response.data.value)
                        this.snackbar("Data Berhasil Ditambahkan...",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Ditambahkan",'is-danger')
                        }else{
                            this.snackbar("Ada Inputan Salah.Silahkan coba lagi",'is-danger')
                        }
                    });
                }
            },
             editData(editID)
            {
                this.isLoading = true
                if(this.checkDataUbah()== false)
                {
                    this.snackbar("Gagal Diedit",'is-danger')
                    this.isLoading = false
                }else{
                    this.editDataSekolah.nama_sekolah = this.form.nama_sekolah.value
                    this.editDataSekolah.nama_kepala_sekolah =this.form.nama_kepala_sekolah.value
                    this.editDataSekolah.alamat = this.form.alamat.value
                    this.editDataSekolah.kota = this.form.kota.value
                    this.editDataSekolah.status_sekolah = this.form.status_sekolah.value
                    this.editDataSekolah.email = this.form.email.value
                    this.editDataSekolah.provinsi = this.form.provinsi.value
                    this.editDataSekolah.jenjang_sekolah = this.form.jenjang_sekolah.value
                    this.editDataSekolah.no_telepon = this.form.no_telepon.value
                    this.editDataSekolah.total_guru = this.form.total_guru.value
                    this.editDataSekolah.total_rombel = this.form.total_rombel.value
                    
                    console.log(editID)
                    console.log(this.editDataSekolah)

                    var uri = this.$apiUrl + 'sekolah/' +editID;
                    this.$http.post(uri,this.editDataSekolah, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({name: "BerandaSekolah"})
                        this.snackbarMessage = response.data.message
                        //console.log(response.data.value)
                        this.snackbar("Data Berhasil Diedit",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Diedit",'is-danger')
                        }else{
                            this.snackbar("Ada Inputan Salah.Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
            },
            confirm()
            {
                this.editID == 0? this.tambahData() : this.editData(this.editID)
            },
             snackbar(snackbarMessage,type)
            {
                this.$buefy.toast.open({
                    duration : 5000,
                    message: snackbarMessage,
                    type: type,
                    position: 'is-top',
                    actionText :'OK',
                    queue: false,
                })
            }, 
        },
        mounted()
        {
            if(this.$session.exists()){
                this.config = {
                    headers: {
                       'Authorization': 'Bearer ' + this.$session.get('token')
                    }
                }
            }
             this.activeBiro = this.$session.get('biro')
             console.log(this.activeBiro) 
           
             if(this.$route.params.id)
            {
                this.editID = this.$route.params.id
                this.actionTitle = 'Ubah'
                // console.log(this.editID)
                this.getData(this.editID)
            }else{
                this.actionTitle = 'Tambah'
            }
            // this.isLoading=false

        }
    }
</script>

<style scoped>
.mw-980 {
  max-width: 980px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.mw-420 {
    max-width: 420px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
</style>